const ORDINAL_SUFFIXES = ["th", "st", "nd", "rd"];

const getOrdinalSuffix = (rank: number): string => {
  const lastDigit = rank % 10;
  const lastTwoDigits = rank % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return ORDINAL_SUFFIXES[0];
  }

  return ORDINAL_SUFFIXES[lastDigit] || ORDINAL_SUFFIXES[0];
};

export const formatRank = (rank?: number): string => {
  if (rank !== undefined) {
    return `${rank}${getOrdinalSuffix(rank)}`;
  }
  return "";
};
